import Block from '_core_ext/core/common/Block';
import plpServices from '_core_ext/components/plp/utils/plpServices';
import dropDownModule from '_core_ext/dropdown';
import eventMgr from '_core_ext/core/eventMgr';
import util from '_core_ext/util';
import addToCart from '../../pages/product/addToCart';

const CHILDREN_COMPONENTS_IDS = [
    'sorting',
    'productView',
    'gridView',
    'productList',
    'refinementsContainer',
    'searchControls',
    'notifyMe'
];

export default class Plp extends Block {
    init() {
        super.init();
        this.settings = {};
        this.initConfig(this.settings);
        this.updateChildrenReferences();
        this.subscribeToChildrenEvents();
        this.productAddedToBagFromQuickShopMsg = this.config.productAddedToBagFromQuickShopMsg;
        plpServices.init();
        addToCart.init();
        dropDownModule.init({
            'options': {
                'globalEvents': 'search.update'
            }
        });

        if (this.$el.find('.js-no-hits').length > 0) {
            $(document).trigger('search.nohit', '.js-no-hits');
        }


        if (this.config.loadOnInit) {
            var viewModeParams = {};
            var searchQueryUrl = location.href.split('#')[0];

            if (this.config.definedViewModes.indexOf('productViewMode') < 0) {
                // get product view mode from local storage or default value
                this.getById('productView', (component) => {
                    viewModeParams.productViewMode = component.getStoredViewMode() || component.currentViewMode;
                });
            }

            if (this.config.definedViewModes.indexOf('gridViewMode') < 0) {
                // get grid view mode from local storage or default value
                this.getById('gridView', (component) => {
                    viewModeParams.gridViewMode = component.getStoredViewMode() || component.currentViewMode;
                });
            }
            this.handleSearchQueryChanges({
                url: util.appendParamsToUrl(searchQueryUrl, viewModeParams),
                historyUrl: searchQueryUrl
            });
        }

        this.event('click', '.js-show-filters-trigger', this.triggerFiltersClick.bind(this));
        this.event('click', '.js-toggle-description-button', this.toggleDescription.bind(this));
        this.eventMgr('window.modechanged', this.onWindowModeChanged.bind(this));

        if (this.refinementsContainer && this.refinementsContainer !== 'undefined') {
            this.refinementsContainer.preExpandRefinements();
            this.expandedRefinements = this.refinementsContainer.getExpandedRefinements();
        }

        this.checkOverflowCategoryDescription();
        
        //plp banners show based on conditions
        this.plpBannerShowHide();

        //expand read more functionality
        this.expandReadMore();
    }

    findFirstNonEmptyPara(showReadMore) {
        const seoParas = $(showReadMore).find('p');
        if (seoParas.length > 0) {
            seoParas.toArray().some(function(seoPara) {
                if ($(seoPara).html().replace(/\s|&nbsp;/g, '').length > 0) {
                    $(seoPara).addClass('c-first-para');
                    return true;
                } else {
                    $(seoPara).remove();
                }
            });
        }
    }

    expandReadMore() {
        var showReadMore = document.getElementsByClassName('show-read-more')[0];
        if (showReadMore) {
            var readMoreseo = Resources.VIEWMORE;
            var readLessseo = Resources.VIEWLESS;
            this.findFirstNonEmptyPara(showReadMore);
            $('<a href="javascript:void(0);" class="read-more"><span class="read-more-text">' + readMoreseo + '</span><span class="arrow arrow-down"></span></a>').insertAfter($('.c-seo-content'));
            var readMore = $(".read-more");
            var readMoreText = readMore.find('.read-more-text');
            readMore.click(function () {
                if (!$(this).hasClass('read-less')) {
                    readMoreText.text(readLessseo);
                    $(this).addClass('read-less');
                    $(showReadMore).addClass('read-less');
                    $(this).find('.arrow').removeClass('arrow-down').addClass('arrow-up');
                } else {
                    readMoreText.text(readMoreseo);
                    $(this).removeClass('read-less');
                    $(showReadMore).removeClass('read-less');
                    $(this).find('.arrow').removeClass('arrow-up').addClass('arrow-down');
                }
            });
        }
    }

    plpBannerShowHide(){
        var $genericBanner = $('.pt_product-search-result .promo-banner.generic');
        var $topCatBanner = $('.pt_product-search-result .promo-banner.top-cat');
        if($genericBanner.length > 0 && $topCatBanner.length > 0){
            var $childCatBanner = $('.pt_product-search-result .promo-banner.child-cat');
            if($childCatBanner.children().length > 0){
                $childCatBanner.show();
            } else if($topCatBanner.children().length > 0 && !$childCatBanner.length){
                $topCatBanner.show();
            } else {
                $genericBanner.removeClass('is--hidden');
            }
        }
    }

    toggleDescription() {
        this.$el.find('.js-toggle-description').toggleClass('is--opened');
    }

    isOverflowing($element) {
        return $element.get(0).scrollWidth > $element.get(0).offsetWidth;
    }

    addOverflowStatus($element) {
        var $toggleDescriptiom = this.$el.find('.js-toggle-description').not('.is--opened');
        if (this.isOverflowing($element)) {
            $toggleDescriptiom.addClass('o-collapsible');
        } else {
            $toggleDescriptiom.removeClass('o-collapsible');
        }
    }

    checkOverflowCategoryDescription() {
        var $categoryDescription = this.$el.find('.js-toggle-description');

        if (!$categoryDescription.length) {
            return;
        }

        var $categoryDescriptionText = $categoryDescription.find('.js-text-container');
        this.addOverflowStatus($categoryDescriptionText);
    }

    onWindowModeChanged() {
        this.checkOverflowCategoryDescription();
    }

    triggerFiltersClick() {
        let $header = $('.header');
        if ($header.hasClass('hide')) {
            $header.removeClass('hide');
        }
        this.refinementsContainer.$el.find('.js-show-filters').click();
    }

    getPlp(queryParams) {
        return eventMgr.execute('get.plp', queryParams);
    }

    getRefinementApplyUrl(queryParams) {
        return eventMgr.execute('get.refinement.apply.url', queryParams);
    }

    renderPlp(plpHtml) {
        var tmpDOM = $('<div>').append(plpHtml);
        var targetResultElement = tmpDOM.find('.js-products-container');
        this.$el.find('.js-products-container').html(targetResultElement.html()).removeClass('c-product-result__init-height');
        targetResultElement.remove();
        return eventMgr.execute('components.update', this.$el);
    }

    /**
    * @private
    * @function
    * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a
    *              loading indicator over the product listing
    */
    handleSearchQueryChanges (queryParams) {
        let $header = $('.header');
        if ($header.hasClass('hide')) {
            $header.removeClass('hide');
        }
        return this.getPlp(queryParams)
            .then((plpHtml) => {
                return this.renderPlp(plpHtml);
            })
            .then(() => {
                history.pushState({}, document.title, (queryParams.historyUrl || queryParams.url));
                this.updateChildrenReferences();
                this.subscribeToChildrenEvents();
                dropDownModule.init({
                    'options': {
                        'globalEvents': 'search.update'
                    }
                });
                $(document).trigger('init.all.carousels.insideselector', this.$el);
                if (this.refinementsContainer && this.refinementsContainer !== 'undefined') {
                    this.refinementsContainer.expandRefinements(this.expandedRefinements);
                }
                $(document).trigger('plp.productLoaded');
                $(document).trigger('plpCategory.productLoaded');
            });
    }

    applyRefinementsChanges(params) {
        this.getRefinementApplyUrl(params)
            .then((data) => {
                if (!data.url) {
                    return;
                }

                this.onHandleSearchQueryChanges({
                    url: data.url
                });
            });
    }

    /* eslint-disable */
    subscribeToChildrenEvents() {
        this.onChild('productView', 'productView.mode.changed', (queryParams) => {
            this.$el.trigger('viewMode.product.modeChanged', {
                productViewMode: this.productView.getViewMode(), 
                gridViewMode: this.gridView ? this.gridView.getViewMode() : undefined
            });
        });
        this.onChild('gridView', 'gridView.mode.changed', (queryParams) => {
            this.$el.trigger('viewMode.grid.modeChanged', {
                productViewMode: this.productView ? this.productView.getViewMode() : undefined, 
                gridViewMode: this.gridView.getViewMode()
            });
            this.onHandleSearchQueryChanges(queryParams);
        });
        this.onChild('refinementsContainer', 'refinementsContainer.refinement.selected', this.onHandleSearchQueryChanges.bind(this));
        this.onChild('refinementsContainer', 'refinementsContainer.refinement.applied', this.applyRefinementsChanges.bind(this));
        this.onChild('refinementsContainer', 'refinementsContainer.refinement.display.change', this.onRefinementDisplayChange.bind(this));
        this.onChild('sorting', 'sorting.sort.rule.selected', this.onHandleSearchQueryChanges.bind(this));
        this.onChild('productList', 'productList.grid.updated', this.onGridUpdated.bind(this));
        this.onChild('productList', 'productList.notifyme', this.onNotifyMe.bind(this));
        this.onChild('productList', 'productList.product.added.to.cart', this.onProductAddedToCart.bind(this));
        this.onChild('searchControls', 'searchControls.pagination.link.clicked', this.onHandleSearchQueryChanges.bind(this));
        this.onChild('notifyMe', 'notifyMe.form.submit', this.onNotyFeFormSubmit.bind(this));
        this.onChild('notifyMe', 'notifyMe.dialog.close', this.onNotifyMeDialogClose.bind(this));
    }
    /* eslint-enable */

    updateChildrenReferences() {
        CHILDREN_COMPONENTS_IDS.forEach((childComponentId) => {
            this.getById(childComponentId, (childComponent) => {
                this[childComponentId] = childComponent;
            });
        });
    }

    onGridUpdated(params) {
        var {paginationParams} = params;
        [
            'sorting',
            'productView',
            'gridView',
        ].forEach((cmpId) => {
            if (this[cmpId]) {
                this[cmpId].updateQueryUrls(paginationParams);
            }
        });
    }

    onNotifyMe(params) {
        this.notifyMe.show(params);
    }

    onNotyFeFormSubmit() {
        this.productList.notifyMeFormSubmited();
    }

    onNotifyMeDialogClose(wasFormSubmitted) {
        if (wasFormSubmitted) {
            return;
        }
        this.productList.onNotifyMeDialogClose();
    }

    onRefinementDisplayChange(params) {
        if (params.isExpanded) {
            this.expandedRefinements.push(params.refinementId);
        } else {
            this.expandedRefinements = this.expandedRefinements.filter((id) => id !== params.refinementId);
        }
    }

    onHandleSearchQueryChanges(queryParams) {
        util.scrollTo(0, 0);
        this.handleSearchQueryChanges(queryParams);
    }

    onProductAddedToCart() {
        var $productAddedToCartMsg = this.$el.find('.js-product-added-to-cart-msg');

        $productAddedToCartMsg.text(this.productAddedToBagFromQuickShopMsg);
        $productAddedToCartMsg.removeClass('is--hidden');
        setTimeout(() => {
            $productAddedToCartMsg.addClass('is--hidden');
            $productAddedToCartMsg.text('');
        }, 2000);
    }
}